module.exports = __webpack_public_path__ + "static/media/co.11131041.svg";